import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=551b2fd8&scoped=true&"
import script from "./app-main.vue?vue&type=script&lang=js&"
export * from "./app-main.vue?vue&type=script&lang=js&"
import style0 from "./app-main.vue?vue&type=style&index=0&id=551b2fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b2fd8",
  null
  
)

export default component.exports